import React from 'react';

import { getByKey } from 'utils';

import icons from '../../styles/flags.css';
import styles from './flagIcon.scss';

interface Props {
    countryCode: string | null;
}

const FlagIcon: React.FC<Props> = ({ countryCode }) => {
    if (countryCode == null) return null;

    const id = `icon-${countryCode}` as const;

    const iconStyleName = getByKey(icons, id) || '';

    return (
        <div
            className={`${styles.wrapper} ${iconStyleName} __app-FlagIcon-container`}
        />
    );
};

export default React.memo(FlagIcon);
